// routeGuards.js - Router guard utilities for authentication and profile checks
// Extracted from App.jsx for better modularity and reusability

/**
 * Check if user has a profile username set
 * @param {Object} user - User object
 * @returns {boolean} - True if user has profile username
 */
export function hasProfileUsername(user) {
  if (!user) return false;
  return !!user.profile_username;
}

/**
 * Check if user can access admin routes
 * @param {Object} user - User object
 * @returns {boolean} - True if user has admin access
 */
export function canAccessAdminRoutes(user) {
  if (!user) return false;
  if (!isEmailVerified(user)) return false;
  return user.is_admin === true;
}

/**
 * Get the redirect path after login based on user state
 * @param {Object} user - User object
 * @returns {string} - Path to redirect to
 */
export function getLoginRedirectPath(user) {
  if (!user) return '/';

  // Always redirect to app home (Explore) after login
  return '/';
}

/**
 * Check if a logged-in user has verified their email address.
 * OAuth users are always considered verified.
 * @param {Object} user - User object
 * @returns {boolean} - True if the user's email is verified
 */
export function isEmailVerified(user) {
  if (!user) return false;
  return user.is_email_verified === true;
}
